import React, {
	Component
} from 'react';

import { store } from '../stores/mainStore';
import styled from 'styled-components';
import {observer} from 'mobx-react';
import {observable} from 'mobx';
import { motion } from 'framer-motion';

import {padStart, times, max} from 'lodash';
import { ButtonMover } from './Buttons';
import { integration } from '../integration';


const RewardBanner = styled(motion.div)`
	position: absolute;
	top: 15vw;
	margin: 0 !important;
	padding: 0;
	height: 100vh;
	z-index: 2000;
	width: 100vw;
`

const Inner = styled.div`
	position: relative;
	height: 100%;
	width: 100%;
`

const Heart = styled(motion.img)`
	width: 10vw;
	position: absolute;
	z-index: 2500;
`
const RewardPanel = styled(motion.div)`
	width: 90vw;
	height: 45.1vw;
	left: 5vw;
	position: absolute;
	background-size: 100% auto;
	& .timer {
		position: absolute;
		top: 15vw;
		left: 0vw;
		font-size: 9vw;
		color: white;
		text-align: center;
		width: 100%;
		line-height: 0.8em;
		text-shadow: 0.5vw 0.3vw 0.3vw black;
		& > span {
			font-size: 6vw;
		}
	}
	& .watch-button {
		position: absolute;
		top: 47vw;
		left: 20vw;
		width: 50vw;
		& img {
			width: 50vw;
		}
	}
	& .qty {
		color: white;
		font-size: 5vw;
		font-weight: 500;
		text-shadow: 0.3vw 0.3vw 0.3vw #830178, -0.3vw -0.3vw 0.3vw #830178, 0.3vw -0.3vw 0.3vw #830178, -0.3vw 0.3vw 0.3vw #830178;
		letter-spacing: -0.3vw;
		position: absolute;
		top: 5.5vw;
		left: 7.5vw;
		width: 10vw;
		text-align: center;
	}
	& .close {
		position: absolute;
		top: -5vw;
		right: -5vw;
		width: 13vw;
		& img {
			width: 13vw;
		}
	}
`

const WatchButtonWrap = styled.div`
	filter: grayscale(${p => p.active ? 0 : 100}%);
`

@observer
export class TopBarAdModal extends Component {
	constructor(props){
		super(props);
		this.state = {
			claimTime: this.calculateClaimTime()
		}
		if(props.countdown){
			this.interval = setInterval(this.updateClaimTime ,1000);
		}
	}

	@observable watchButtonReady = true;

	componentWillUnmount(){
		clearInterval(this.interval);
	}

	updateClaimTime = () => {
		this.setState({
			claimTime: this.calculateClaimTime()
		});
	}

	calculateClaimTime = () => {
		var time = store.user.localClaimTime - Date.now();
		var second = 1000;
		var minute = second * 60;
		var hour = minute * 60;
		if(time <= 0){
			return true;
		}
		if(store.user.localClaimTime){
			let r = [0,0,0];
			[hour,minute,second].forEach((t,i) => {
				while(time >= t){
					r[i]++;
					time -= t;
				}
			})
			return r;
		} else {
			return [-1,-1,-1];
		}
	}

	watchVideo = () => {
		this.watchButtonReady = false;
		//Prevent opening the "standard" ad return modal.
		store.autoOpenModalAfterAd = false;
		window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent('timer_watch_ad','economy');
		if(store.enableRewardAds && store.rewardAdIsLoaded) {
			if(!(window.location.port === '3000' || window.location.hash === '#dev')) {
				window.WrapperApp.postMessage("show-rewardVideo?name=default");
				setTimeout(this.dimPanel, 150);
			} else {
				store.rewardAdModalHearts = 1;
			}
		}
	}
	dimPanel  = () => {
		store.modal = 'videoDimPanel';
	}

	onHeartsComplete = () => {
		store.rewardAdModalHearts = 0;
		store.autoOpenModalAfterAd = true;
		this.watchButtonReady = true;

		window.manager.rewardVideoAddHearts();
		integration.postAnalyticsEvent('reward_watch_ad_timer','economy')

		if(this.props.onHeartsComplete){
			this.props.onHeartsComplete();
		}
	}

	close = () => {
		window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent('timer_return_to_menu','navigation')
		store.showCountdownModal = false;
	}

	render(){
		var delayBeforeFirstHeart = 1;
		var delayIncrement = 0;
		return (
			<React.Fragment key="countdown-ad-hearts">
				<RewardBanner key="achievement">
					<Inner>
						<RewardPanel
							style={{
								backgroundImage: `url("/assets/languages/${store.settings.language}/popup_free_hearts_in.png")`
							}}
							initial={{y: '-80vw', opacity: 1}}
							exit={{
								y: '-80vw',
								opacity: 0,
								transition: {type: 'tween', duration: 0.5}
							}}
							animate={{y: store.aspectIs('Tablet') ? '25vw' : '50vw', opacity: 1}}
							transition={{
								y: {type: "spring", stiffness: 300, damping: 25, mass: 1.5}
							}}
						>
							<Inner>
								<div className="timer">
									{padStart(this.state.claimTime[0].toString(),2,0)}:{padStart(this.state.claimTime[1].toString(),2,0)}:{padStart(this.state.claimTime[2].toString(),2,0)}
								</div>
								<div className="close">
									<ButtonMover onClick={this.close}>
										<img alt="close" src="/assets/btn_close.png"/>
									</ButtonMover>
								</div>
								<div className="qty">
									+{store.user.level > 10 ? 2 : 1}
								</div>
								{this.watchButtonReady && (
									<WatchButtonWrap className="watch-button" active={store.rewardAdIsLoaded}>
										<ButtonMover onClick={store.rewardAdIsLoaded ? this.watchVideo : undefined}>
											<img alt="watch" src={`/assets/languages/${store.settings.language}/btn_watch.png`}/>
										</ButtonMover>
									</WatchButtonWrap>
								)}
							</Inner>
						</RewardPanel>
					</Inner>
				</RewardBanner>
				{times(store.rewardAdModalHearts, (n) => {
					var d = max([(0.15 - (n * 0.01)),0.03]);
					delayIncrement += d;
					window.manager.playAudio("HeartstoHud_single");
					return (
						<Heart
							onAnimationComplete={n + 1 === store.rewardAdModalHearts ? this.onHeartsComplete : null}
							key={`star-${n}`}
							initial={{x: '71vw', y: store.aspectIs('Tablet') ? '67vw' : '92vw', scale: 0}}
							animate={{x: '74vw', y: '-1vw', scale: [0,1,1,0]}}
							transition={{
								default: {delay: delayBeforeFirstHeart + delayIncrement, duration: 0.8, ease: 'easeInOut'}
							}}
							src="/assets/hud/hud_icon_heart.png"
						/>
					);
				})}
			</React.Fragment>
		)
	}
}
